import moment from 'moment'
import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { getFormatParticipants } from 'domain/pricerParticipants'
import * as Actions from 'store/actions/index.ts'
import {
  getBenefitsConf,
  getCurrentProduct,
  getCurrentProductLabelsFormattedForTracking,
  getCurrentResourceSubUniverseName,
  getCurrentResourceUniverseName,
  getDaysSinceStartSale,
  getFilteredProductsInParentScope,
  getHasPackages,
  getHasVisibleDepartureCityPicker,
  getHasVisibleDepartureDatePicker,
  getHasVisibleDurationPicker,
  getIsCheapestPriceToggled,
  getNbSubUniversesInCatalog,
  getNbUniversesInCatalog,
  getOperationCode,
  getPriceUnit,
  getProductCallPrice,
  getProductPriceMsrp,
  getProductPriceUnit,
  getProductPriceValue,
  getProductTitle,
  getSaleStartTime,
  getSelectedBenefits,
  getSelectedCheckin,
  getSelectedDepartureCity,
  getSelectedDuration,
  getSelectedParticipants
} from 'store/selectors'
import { track } from 'tracking/mixPanel'

const getInfosWithoutPackage = (eventName, state) => {
  const currentProduct = getCurrentProduct(state)
  const daysSinceStartSale = getDaysSinceStartSale(state)
  const nbSubUniverses = getNbSubUniversesInCatalog(state)
  const nbUniverses = getNbUniversesInCatalog(state)
  const products = getFilteredProductsInParentScope(state)
  const productCallPrice = getProductCallPrice(state)
  const productTitle = getProductTitle(state)
  const operationCode = getOperationCode(state)
  const saleStartTime = getSaleStartTime(state)
  const subUniverseName = getCurrentResourceSubUniverseName(state)
  const universeName = getCurrentResourceUniverseName(state)
  const productPriceValue = getProductPriceValue(state)
  const productPriceUnit = getProductPriceUnit(state)
  const productPriceMsrp = getProductPriceMsrp(state)

  return {
    '# of References': products.length,
    '# of Sub Universes': nbSubUniverses,
    '# of Universes': nbUniverses > 1 ? nbUniverses : 0,
    'Cheapest price toggle ON': false,
    'Days Since Sale Start': daysSinceStartSale,
    'Event Name': eventName,
    ...getCurrentProductLabelsFormattedForTracking(state),
    'Lowest Price': productCallPrice,
    'Operation Code': operationCode,
    'Product': productTitle,
    'Product ID': currentProduct.ecomm.externalId,
    'Product Price': productPriceValue,
    'Ref price': !!productPriceMsrp,
    'Sale Start Time': saleStartTime,
    'Under Universe': nbUniverses > 1 ? subUniverseName : '',
    'Unit': productPriceUnit,
    'Universe': nbUniverses > 1 ? universeName : ''
  }
}

const getInfosWithPackage = (eventName, state) => {
  const hasVisibleDepartureCityPicker = getHasVisibleDepartureCityPicker(state)
  const hasVisibleDepartureDatePicker = getHasVisibleDepartureDatePicker(state)
  const hasVisibleDurationPicker = getHasVisibleDurationPicker(state)
  const isCheapestPriceToggled = getIsCheapestPriceToggled(state)
  const selectedCheckin = getSelectedCheckin(state)
  const selectedDepartureCity = getSelectedDepartureCity(state)
  const selectedDuration = getSelectedDuration(state)
  const selectedParticipants = getSelectedParticipants(state)
  const benefitsConf = getBenefitsConf(state)
  const selectedBenefits = getSelectedBenefits(state)
  const packagePriceUnit = getPriceUnit(state)

  return ({
    ...getInfosWithoutPackage(eventName, state),
    'Cheapest price toggle ON': isCheapestPriceToggled,
    'Departure City': hasVisibleDepartureCityPicker ? selectedDepartureCity.label : undefined,
    'Family Config': selectedParticipants ? getFormatParticipants(selectedParticipants) : undefined,
    'Interaction Type': 'Click',
    'Number Of Nights': hasVisibleDurationPicker ? selectedDuration.nights : undefined,
    'Number Of Offer Type Selected': selectedBenefits,
    'Offer Type Category': benefitsConf?.labels.singular,
    'Search Date': hasVisibleDepartureDatePicker ? moment(selectedCheckin).format('YYYY-MM-DDTHH:mm:ss') : undefined,
    'Unit': packagePriceUnit
  })
}

const mapStateToMPEvent = (eventName, state) => {
  const operationCode = getOperationCode(state)

  if (!operationCode) { return null }

  return getHasPackages(state)
    ? getInfosWithPackage(eventName, state)
    : getInfosWithoutPackage(eventName, state)
}

const tooltipEventEpic = (
  actions$,
  state$
) => actions$.pipe(
  ofType(Actions.configurator.CLICK_VALIDATION),
  tap(() => {
    const eventName = 'Classic Complete Add To Cart'

    track(eventName, mapStateToMPEvent(eventName, state$.value), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default tooltipEventEpic
